<template>
	<div>
		<div class="foot-nav-height"></div>
		<div class="foot-nav " >
			
			<div style=" display: inline-flex;white-space: nowrap;">
				<template v-for="(item,index) in list">
					<router-link class="a fcc-h" :to="item.url"  :key="index" v-if="item.url">
						<span class="fcc" :class="{'auto':item.name.length<4}">{{item.name}}</span>
					</router-link>
					<div class="a fcc-h" :key="index" v-else>
						<span class="fcc" :class="{'auto':item.name.length<4}">{{item.name}}</span>
					</div>
				</template>
			</div>
			
		</div>
	</div>
</template>

<script>
	export default {
		name: "i-nav",
		props: {
			index: {
				type: [Number,String],
				default: 0
			},
		},
		data() {
			return {
				list:[
					{
						name:"任务指南",
						url:"/task-guide"
					},
					{
						name:"培训议程",
						url:"/training-agenda"
					},
					{
						name:"玩家集结",
						url:"/collect"
					},
					{
						name:"任务打卡",
						url:"/task-checkin"
					},
					{
						name:"积分排行",
						url:"/points-ranking"
					},
					{
						name:"活动相册",
						url:"/photo-album"
					},
					{
						name:"朋友圈",
						url:"/wechat-moments"
					}
				]
			};
		},
		mounted() {

		},
		watch: {

		},
		methods: {
			

		},
	};
</script>
<style lang="less" scoped>
	.foot-nav-height{
		height: 170px;
	}
	.foot-nav{
		height: 170px;
		position: fixed;
		width: 100%;
		left: 0;
		bottom: 0;
		z-index: 88;
		background:rgba(56, 114, 255,0.72);
		overflow: hidden;
		overflow-x: auto;
		display: flex;
		align-items: center;
		padding-left: 15px;
		padding-right: 15px;
		-webkit-overflow-scrolling: touch;
		.a{
			width: 128px;
			height: 100px;
			background: #FFFFFF;
			box-shadow: 0px 9px 6px 0px rgba(19,111,187,0.15);
			border-radius: 10px;
			border: 1px solid #CEDAF7;
			
			span{
				text-align: center;
				width: 2.5em;
				line-height:1.5em;
				font-weight: bold;
				font-size: 28px;
				color: #3872FF;
				line-height: 36px;
			}
			.auto{
				width: 100%;
			}
		}
		.a+.a{
			margin-left: 15px;
		}
		.router-link-active{
			
			background: #FACD89;
			box-shadow: 0px 9px 6px 0px rgba(19,111,187,0.15);
			border-radius: 10px;
			border: 1px solid #CEDAF7;
			span{
				color: #9B6006;
			}
		}
	}

	.list6{
		padding-left: 10px;
		padding-right: 10px;
		box-sizing: border-box;
		.a + .a{
			margin-left: 8px;
		}
	}
</style>